import script from "./DetailsSLR.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailsSLR.vue?vue&type=script&setup=true&lang=ts"

import "./DetailsSLR.vue?vue&type=style&index=0&id=dad3c19a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dad3c19a"]])

export default __exports__